import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "font-weight-normal" }
const _hoisted_3 = ["checked", "onChange"]
const _hoisted_4 = { class: "margin-left-5" }
const _hoisted_5 = {
  key: 1,
  class: "ajax-loader"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-box-container", {'display-flex justify-content-center align-items-center': !_ctx.ShowInputControlContainer()}])
  }, [
    (_ctx.ShowInputControlContainer())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInputData, (data) => {
            return (_openBlock(), _createElementBlock("div", { key: data }, [
              _createElementVNode("label", _hoisted_2, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: data.IsChecked,
                  onChange: ($event: any) => (_ctx.AddOrRemoveItem(data.Id))
                }, null, 40, _hoisted_3),
                _createElementVNode("span", _hoisted_4, _toDisplayString(data.Label), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_ctx.localInputData === null || _ctx.localInputData === undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "img-responsive ajax-loader-img",
              src: _ctx.loadingImage,
              alt: "Wait"
            }, null, 8, _hoisted_6)
          ]))
        : (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(_ctx.$t("Dialogue.Filter.NoGroupCreatedYet")), 1))
  ], 2))
}